<template>
    <div class="BusinessDetailsCenter_Right">
        <!-- 项目详情-联系信息 -->
    
        <div class="head">
            <div class="nav">
                <div class="nav_div nav_div_active">联系信息</div>
            </div>
        </div>


        <div class="BusinessDetailsCenterRightContent">
            <div class="center">
                <div class="centerButton" v-if="!loginType">
                    <!-- <div class="centerButton" v-if="loginType"> -->

                    <el-row>
                        <el-col :xs="12" :sm="12" :offset="6" class="loginButton hidden-xs-only ">
                            登录后查看
                        </el-col>
                        <el-col :xs="10" :sm="12" :offset="7" class="loginButton hidden-sm-and-up">
                            登录后查看
                        </el-col>
                    </el-row>
                </div>
                <div class="centerContent" v-else>
                    <el-row class="site">
                        <el-col :xs="4" :sm="4">地址:</el-col>
                        <el-col :xs="20" :sm="20">{{msg.place}}</el-col>
                    </el-row>
                    <el-row class="tel">
                        <el-col :xs="4" :sm="4">电话:</el-col>
                        <el-col :xs="20" :sm="20">{{msg.phone}}</el-col>
                    </el-row>
                    <el-row class="mail">
                        <el-col :xs="4" :sm="4">邮箱:</el-col>
                        <el-col :xs="20" :sm="20">{{msg.mailbox}}</el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            loginType: Boolean,
            msg:Object,
        },
        components: {

        },
        data() {
            return {
            }
        },
        created: function () {

        },
        methods: {},

    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .head .nav {
            margin-left: 15px;
        }

        .head .nav_div {
            font-size: 24px;
        }

        .head .nav_div_active::after {
            /* content: ""; */
            /* display: block; */
            width: 95px;
            height: 7px;
            /* background-color: #00ffff; */
            border-radius: 4px;
            /* margin-top: 20px; */
            /* position: relative; */
            /* z-index: 1; */
        }
    }

    .head {
        background-color: #2c2c2c;
        border-radius: 25px 25px 0 0;

    }

    .nav {
        display: flex;
        justify-content: left;
        margin-left: 31px;
    }

    .nav .nav_div:last-child {
        margin-right: 0px;
    }

    .nav_div {
        padding: 21px 0;
        margin-right: 37px;

        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #999999;
        position: relative;
    }

    .nav_div_active {
        color: #ffffff;
    }

    .nav_div_active::after {
        content: '';
        position: absolute;
        bottom: 1px;
        display: block;
        width: 41px;
        height: 5px;
        background-color: #00fefe;
        border-radius: 2px;

    }


    @media (max-width: 768px) {
        .BusinessDetailsCenterRightContent .centerContent {
            padding-top: 20px;
            padding-bottom: 20px;
            margin: 0 15px;
        }
    }

    .BusinessDetailsCenterRightContent {
        background-color: #1d1d1f;
        border-radius: 0 0 25px 25px;
    }

    .center {
        /* padding-top: 86px;
    padding-bottom: 110px; */

    }

    .centerButton {
        padding-top: 86px;
        padding-bottom: 110px;
    }

    .loginButton {
        border-radius: 17px;
        border: solid 1px #dcdcdc;

        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #dcdcdc;
        padding: 7px 25px;
        text-align: center;

    }

    .centerContent {
        padding-top: 40px;
        padding-bottom: 51px;
        margin: 0 30px;


    }

    .site {

        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 17px;
        letter-spacing: 0px;
        color: #dcdcdc;
    }

    .tel {
        margin-top: 17px;

        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 17px;
        letter-spacing: 0px;
        color: #dcdcdc;
    }

    .mail {
        margin-top: 17px;

        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 17px;
        letter-spacing: 0px;
        color: #dcdcdc;
    }
</style>